<template>
  <div class="table-header-tool">
    <el-popover class="popover-content" trigger="hover" :disabled="!haveActions" placement="bottom-start">
      <div class="text-content" slot="reference">
        <div class="title single-ellipsis">
          <el-tooltip effect="dark" :content="tipText" :disabled="!tipText" placement="top">
            <div>
              <div class="title single-ellipsis">
                <i
                  v-if="iconInfo"
                  class="iconfont"
                  :class="iconInfo.name"
                  :style="iconInfo.color ? { color: iconInfo.color } : {}"
                ></i>
                <span>{{ title }}</span>
              </div>
              <i class="arrow-down el-icon-arrow-down" v-show="haveActions"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="tool-ul">
        <div class="tool-group-name" v-if="curUnitGroup">
          <span>{{ curUnitGroup.name }}</span>
        </div>
        <div class="tool-item" :class="item.iconName ? 'have-icon' : ''" v-for="(item, key) in actions" :key="key">
          <i class="iconfont" v-if="item.iconName" :class="item.iconName" />
          <div
            class="tool-btn single-ellipsis"
            :style="formatStyle(item.actions)"
            v-for="subItem in item.actions"
            :key="subItem.action"
            @click="toolHandle(subItem.action)"
          >
            <span>{{ subItem.formatter ? subItem.formatter(title) : subItem.title }}</span>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: '-'
    },
    tipText: {
      type: String,
      default: ''
    },
    actions: {
      type: Object,
      default: () => ({})
    },
    iconInfo: {
      type: Object,
      default: () => ({})
    }
  },
  inject: {
    curUnitGroup: { default: () => null }
  },
  computed: {
    haveActions() {
      return Object.keys(this.actions).length > 0;
    }
  },
  methods: {
    toolHandle(action) {
      this.$emit('toolHandle', action);
    },
    formatStyle(actions) {
      if ((actions || []).length < 2) {
        return { width: '100%' };
      }
      return { width: `${Math.floor((1 / actions.length) * 100)}%` };
    }
  }
};
</script>

<style lang="scss" scoped>
.table-header-tool {
  position: relative;
  $headerHeight: 32px;
  height: $headerHeight;

  ::v-deep .popover-content {
    position: relative;
    box-sizing: border-box;
    display: block;
    width: calc(100% - 3px);
    padding: 0px;
    cursor: pointer;
    z-index: 2;

    .el-popover__reference-wrapper {
      display: block;
      width: 100%;
      height: $headerHeight;
      line-height: $headerHeight;

      .el-popover__reference {
        display: block;
        width: 100%;
      }
    }

    .text-content {
      box-sizing: border-box;
      position: relative;
      display: block !important;
      width: auto !important;
      max-width: 100%;
      padding-right: 20px;
      overflow: visible;

      .title {
        box-sizing: border-box;
        color: rgba(#2c3443, 0.8);
        width: 100%;
        height: $headerHeight;
        padding-left: 4px;

        .iconfont {
          position: relative;
          top: 1px;
          height: 14px;
          margin-right: 2px;
        }
      }

      .arrow-down {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      .tool-icon {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
        opacity: 0;

        &.show {
          opacity: 1;
        }
      }

      &:hover {
        .tool-icon {
          opacity: 1;
        }
      }
    }
  }
}
.tool-ul {
  width: 308px;

  .tool-group-name {
    height: 30px;
    line-height: 30px;
    color: #9599a5;
    font-size: 12px;
    padding: 0 16px;
    background-color: #e8ebef;
  }

  .tool-item {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #2c3443;
    padding: 0px 12px;
    cursor: pointer;

    &.have-icon {
      padding-left: 40px;
    }

    .tool-btn {
      padding: 0 4px;
    }

    .iconfont {
      position: absolute;
      left: 16px;
      top: 50%;
      color: rgba(#2c3443, 0.8);
      transform: translateY(-50%);
      margin-right: 10px;
    }

    &::after {
      position: absolute;
      left: -12px;
      bottom: 0;
      content: ' ';
      height: 1px;
      width: calc(100% + 24px);
      background-color: rgba(#e8ebef, 0.5);
    }

    &:last-child {
      &::after {
        background-color: #fff;
      }
    }
  }
}
</style>
